// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import AimChatController from './aim_chat_controller'

application.register('aim-chat', AimChatController)
